module.exports = __webpack_public_path__ + "img/applebees-logo-dark.641ad634.png";